import { SUM } from '__jsLibs/EXCEL';
const gettersTotalExpenses30years = {
	Principal(state, getters) {
		return +getters.LoanAmount;
	},
	PrincipalPercent(state, getters) {
		return (100 * +getters.Principal) / +getters.TotalOutFromYouExpenses;
	},
	Interest(state, getters) {
		return +getters.ofPayments * +getters.MonthlyPayment - +getters.Principal;
	},
	InterestPercent(state, getters) {
		return (100 * +getters.Interest) / +getters.TotalOutFromYouExpenses;
	},
	PMI(state, getters) {
		return +state.constants['pmi'];
	},
	PMIPercent(state, getters) {
		return (100 * +getters.PMI) / +getters.TotalOutFromYouExpenses;
	},
	TaxesInsurance(state, getters) {
		return +state.constants['taxes_insurance'];
	},
	TaxesInsurancePercent(state, getters) {
		return (100 * +state.constants['taxes_insurance']) / +getters.TotalOutFromYouExpenses;
	},
	OperatingExpenses(state, getters) {
		return +state.constants['operating_expenses'];
	},
	OperatingExpensesPercent(state, getters) {
		return (100 * +state.constants['operating_expenses']) / +getters.TotalOutFromYouExpenses;
	},
	TotalOutFromYouExpenses(state, getters) {
		return SUM([
			+getters.Principal,
			+getters.Interest,
			+getters.PMI,
			+getters.TaxesInsurance,
			+state.constants['operating_expenses']
		]);
	},
	TotalInToYouRevenues(state, getters) {
		return +state.constants['total_in_to_you'];
	},
	TotalCashFlowRevsExps(state, getters) {
		return +state.constants['total_in_to_you'] - +getters.TotalOutFromYouExpenses;
	}
};

export {
	gettersTotalExpenses30years
};
